import { render, staticRenderFns } from "./scrolldown-primary.vue?vue&type=template&id=ed102c26&scoped=true&"
import script from "./scrolldown-primary.vue?vue&type=script&lang=js&"
export * from "./scrolldown-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed102c26",
  null
  
)

export default component.exports